import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../../assets/css/patrocinadores.css';
import { CaretRightOutlined, LeftOutlined } from '@ant-design/icons';

import log_blanco from '../../../assets/images/sitio/03_Patrocinadores_sitio_IES/Ies_Ledvance.png';

import banner from '../../../assets/images/2022/stands/interiores/completos/stands_ind_-ledvance.jpg';

import img_wsp_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_wsp from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_email_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_email from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_wsp_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_wsp_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_email_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';
import img_email_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';

import btn_fb_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_fb from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_tw from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_tw_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_yt from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_yt_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_in from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_in_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_lk from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';
import btn_lk_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';

import { Element } from 'react-scroll';


const Ledvance = (props) => {
  const { Panel } = Collapse;
  const { idioma,onMetrica, nombre } = props;
  const [hover_imagen, setHoverImagen] = useState(0);
  const [hover_redes, setHoverRedes] = useState(0);

  return (
    <>
      <Row align='middle'>
        <Col span={24}>
          <br /><br /><br /><br />
        </Col>
        <Col xs={{ span: 4, offset: 1 }} md={{ span: 2, offset: 2 }}>
                  <p className="salir_patrocinador">
          <Link to="/#patrocinadores" className="salir_patrocinador"><LeftOutlined /> {idioma === 'es' ? 'Salir' : 'Get out'}</Link>
          </p>
        </Col>
        <Col xs={{ span: 8, offset: 1 }} md={{ span: 4, offset: 5 }}>
          {idioma==='es' ?
            <img src={log_blanco} style={{width:'100%'}} />
          :
          <img src={log_blanco} style={{width:'100%'}} />}
        </Col>
      </Row>
      <Row>
      <Col span={24} offset={0}>
        <a href="#video" onClick={()=>{onMetrica('video',nombre)}}>
          <img src={banner} style={{width:'100%'}} onClick={()=>onMetrica('video',nombre)}/>
        </a>
        <br /><br />
        </Col>
        <Col span={0} offset={0}>
          <p className="texto_patrocinadores">
          
        </p>

        </Col>
        <Col span={16} offset={4}>
        <br /><Element name='#video' />
        <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/qCYDU1nEPfo?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <br /><br />
          
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:4}} className="paddin_20">
          {idioma === 'es' ?
          <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525539331373&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20Ledvance%20de%20la%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="video" /></a>
          :
          <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525539331373&text=Hello,%20contact%20me%20from%20the%20Ledvance%20booth%20at%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="video" /></a>
        }
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20">
        {idioma === 'es' ?
        <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:tapiak@ledvance.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_email_hover : img_email} style={{width:'100%'}} alt="video" /></a>
      :
      <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:tapiak@ledvance.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_email_en_hover : img_email_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
       </Row>
      <Row>
        <Col span={16} offset={4}>
          <br /><br />
        </Col>
        <Col span={20} offset={2}>
        {idioma === 'es' ?
          <p className="titulo_patrocinador_texto">PREGUNTAS FRECUENTES</p>
        :
        <p className="titulo_patrocinador_texto">FREQUENT QUESTIONS</p>
        }
        </Col>
        <Col span={20} offset={2}>
          <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="site-collapse-custom-collapse"
          >
            {idioma === 'es' ?
            <Panel header="¿Conoce las diferentes categorías de productos LEDVANCE?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Visita: <a target="_blank" className="texto_patrocinadores_link" href="https://www.ledvance.lat/">www.ledvance.lat</a>
                  </p>
            </Panel>
            :
            <Panel header="Do you know the different LEDVANCE product categories?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Visita: <a target="_blank" className="texto_patrocinadores_link" href="https://www.ledvance.lat/">www.ledvance.lat</a>
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Dónde puedes conseguir información más detallada de productos LEDVANCE?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Consulta y descarga el catálogo 2022:  <br />
                  <a target="_blank" className="texto_patrocinadores_link" href="https://drive.google.com/drive/u/1/folders/1I3lZsvAO4A_GU5_AUzeU_mKQszyR6exp">https://drive.google.com/drive/u/1/folders/1I3lZsvAO4A_GU5_AUzeU_mKQszyR6exp</a>
                  </p>
            </Panel>
            :
            <Panel header="Where can you get more detailed information on LEDVANCE products?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Check and download the 2022 catalog: <br />
                  <a target="_blank" className="texto_patrocinadores_link" href="https://drive.google.com/drive/u/1/folders/1I3lZsvAO4A_GU5_AUzeU_mKQszyR6exp">https://drive.google.com/drive/u/1/folders/1I3lZsvAO4A_GU5_AUzeU_mKQszyR6exp</a>
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Dónde encuentro soluciones y aplicaciones de productos LEDVANCE?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Síguenos en Facebook o Instagram:
                  <br />@ledvancemexico
                  <br />Síguenos en Linkedin:
                  <br />
                  <a target="_blank" className="texto_patrocinadores_link" href="https://www.linkedin.com/in/ledvance-m%C3%A9xico-87a830209/">https://www.linkedin.com/in/ledvance-m%C3%A9xico-87a830209/</a>
                  </p>
            </Panel>
            :
            <Panel header="Where can I find solutions and applications for LEDVANCE products?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Follow us on Facebook or Instagram:
                  <br />@ledvancemexico
                  <br />Follow us on Linkedin:
                  <br />
                  <a target="_blank" className="texto_patrocinadores_link" href="https://www.linkedin.com/in/ledvance-m%C3%A9xico-87a830209/">https://www.linkedin.com/in/ledvance-m%C3%A9xico-87a830209/</a>
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Necesitas una solución con expertos que harán el cálculo exacto de iluminación para tus proyectos?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contacta a nuestra área de proyectos en:<br />
                  <a target="_blank" className="texto_patrocinadores_link" href="proyectosmx@ledvance.com">proyectosmx@ledvance.com</a>
                  </p>
            </Panel>
            :
            <Panel header="Do you need a solution with experts who will make the exact lighting calculation for your projects?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contact our projects area at:<br />
                  <a target="_blank" className="texto_patrocinadores_link" href="proyectosmx@ledvance.com">proyectosmx@ledvance.com</a>
                  </p>
            </Panel>}
            {idioma === 'es' ?
             <Panel header="¿Necesitas asesoría para definir tu proyecto?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <br />
                  <a target="_blank" className="texto_patrocinadores_link" href="proyectosmx@ledvance.com">proyectosmx@ledvance.com</a>
                  </p>
            </Panel>
            :
            <Panel header="Do you need advice to define your project?" key="4" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            
            <a target="_blank" className="texto_patrocinadores_link" href="proyectosmx@ledvance.com">proyectosmx@ledvance.com</a>
            </p>
      </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Sigues con iluminación común? CAMBIATE a Iluminación Inteligente" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contacta a nuestra área de proyectos en:
                  <a target="_blank" className="texto_patrocinadores_link" href="proyectosmx@ledvance.com">proyectosmx@ledvance.com</a>
                  </p>
            </Panel>
            :
            <Panel header="Are you still with common lighting? SWITCH to Smart Lighting" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contact our projects area at:
                  <a target="_blank" className="texto_patrocinadores_link" href="proyectosmx@ledvance.com">proyectosmx@ledvance.com</a>
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="Conoce algunos de nuestros proyectos de iluminación de un vistazo" key="6" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <a target="_blank" className="texto_patrocinadores_link" href="https://www.ledvance.lat/proyectos-verticales/proyectos/index.jsp">https://www.ledvance.lat/proyectos-verticales/proyectos/index.jsp</a>
                  </p>
            </Panel>
            :
            <Panel header="Get to know some of our lighting projects at a glance" key="6" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            <a target="_blank" className="texto_patrocinadores_link" href="https://www.ledvance.lat/proyectos-verticales/proyectos/index.jsp">https://www.ledvance.lat/proyectos-verticales/proyectos/index.jsp</a>
            </p>
      </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Quieres conocer nuestro programa de webinars?" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contacta a Marketing- Karina Tapia:<br />
                  <a target="_blank" className="texto_patrocinadores_link" href="mailto:tapiak@ledvance.com">tapiak@ledvance.com</a>
                  </p>
            </Panel>
            :
            <Panel header="Get to know some of our lighting projects at a glance" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contact Marketing- Karina Tapia:<br />
                  <a target="_blank" className="texto_patrocinadores_link" href="mailto:tapiak@ledvance.com">tapiak@ledvance.com</a>
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Quieres recibir noticias de productos nuevos y tendencias de iluminación?" key="8" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contacta a Marketing- Karina Tapia:
                  <a target="_blank" className="texto_patrocinadores_link" href="mailto:tapiak@ledvance.com">tapiak@ledvance.com</a>
                  </p>
            </Panel>
            :
            <Panel header="Do you want to receive news of new products and lighting trends?" key="8" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contact Marketing- Karina Tapia:
                  <a target="_blank" className="texto_patrocinadores_link" href="mailto:tapiak@ledvance.com">tapiak@ledvance.com</a>
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Dónde puedo comprar productos LEDVANCE?" key="9" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contáctanos de acuerdo con tu región:<br />
                  Zona Centro: 	Raúl Carpio	<a target="_blank" className="texto_patrocinadores_link" href="mailto:Raul.Carpio@ledvance.com">Raul.Carpio@ledvance.com</a><br />
                  Zona Occidente:	Oscar Quezada	<a target="_blank" className="texto_patrocinadores_link" href="mailto:o.quezada@ledvance.com">o.quezada@ledvance.com</a><br />
                  Zona Norte:	Oscar Cortes	<a target="_blank" className="texto_patrocinadores_link" href="mailto:o.cortes@ledvance.com">o.cortes@ledvance.com</a><br />
                  Zona Bajío: 	Oscar Porta	<a target="_blank" className="texto_patrocinadores_link" href="oscar.porta@ledvance.com">oscar.porta@ledvance.com</a><br />
                  Zona Sur:	Isis Calzada	<a target="_blank" className="texto_patrocinadores_link" href="mailto:calzadai@ledvance.com">calzadai@ledvance.com</a>
                  </p>
            </Panel>
            :
            <Panel header="Where can I buy LEDVANCE products?" key="9" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contact us according to your region:<br />
                  Downtown: 	Raúl Carpio	<a target="_blank" className="texto_patrocinadores_link" href="mailto:Raul.Carpio@ledvance.com">Raul.Carpio@ledvance.com</a><br />
                  Western Zone:	Oscar Quezada	<a target="_blank" className="texto_patrocinadores_link" href="mailto:o.quezada@ledvance.com">o.quezada@ledvance.com</a><br />
                  North Zone:	Oscar Cortes	<a target="_blank" className="texto_patrocinadores_link" href="mailto:o.cortes@ledvance.com">o.cortes@ledvance.com</a><br />
                  Bajío Area: 	Oscar Porta	<a target="_blank" className="texto_patrocinadores_link" href="oscar.porta@ledvance.com">oscar.porta@ledvance.com</a><br />
                  South Zone:	Isis Calzada	<a target="_blank" className="texto_patrocinadores_link" href="mailto:calzadai@ledvance.com">calzadai@ledvance.com</a>
                  </p>
            </Panel>}
          </Collapse>
        </Col>
        <Col span={20} offset={2}>
        <br /><br />
        {idioma === 'es' ?
        <p className="tituLogos">Obtener más información</p>
        :
        <p className="tituLogos">Get more information</p>}
        </Col>
        <Col xs={{span:10,offset:7}} md={{span:6,offset:9}}>
        
        <Row justify='center'>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('facebook',nombre)} href="https://www.facebook.com/ledvance" target="_blank" onMouseEnter={()=>setHoverRedes(1)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 1 ? btn_fb_hover : btn_fb} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('twitter',nombre)} href="https://twitter.com/ledvance" target="_blank" onMouseEnter={()=>setHoverRedes(2)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 2 ? btn_lk_hover : btn_lk} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={0} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('youtube',nombre)} href="" target="_blank"><img src={btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={0} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('instagram',nombre)} href="" target="_blank"><img src={btn_in} className="patrocinadores_redes_img" /></a>
          </Col>
        </Row>
        <br />
        </Col>
      </Row>
    </>
  )
}
export default Ledvance;